<template>
  <div class="card">
    <div class="card-header padding_12_20">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <div class="me-3">
            <img src="@/assets/images/svg-img/generation.svg" />
          </div>
          <div>
            <div class="card_title_1">GENERATION</div>
            <div class="card_title_2">Last Updated {{ last_update }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="card-body" style="padding: 0 20px">
      <div class="header-top" style="padding: 12px 0">
        <h5 v-if="selectedRegion == null" class="m-0 sub_title_1">INDONESIA</h5>
        <h5 v-else class="m-0 sub_title_1">
          <span
            @click="deselectRegion"
            style="cursor: pointer; text-decoration: underline; color: grey"
            >INDONESIA</span
          >
          > {{ selectedRegion.instanceName.toUpperCase() }}
        </h5>
        <div style="display: flex; gap: 20px">
          <div class="card-header-right-icon">
            <!-- <select class="form-select custom_select" style="color: #838383">
              <option value="all" selected>All</option>
              <option>PLTA</option>
              <option>PLTB</option>
              <option>PLTBM</option>
              <option>PLTD</option>
              <option>PLTG</option>
              <option>PLTGU</option>
              <option>PLTM</option>
              <option>PLTMG</option>
              <option>PLTMH</option>
              <option>PLTP</option>
              <option>PLTS</option>
              <option>PLTU</option>
            </select> -->
            <select v-model="powerPlant" class="custom-dropdown form-select">
              <option
                v-for="(option, key) in dataPP"
                :key="key"
                :value="option.value"
              >
                {{ option.label }}
              </option>
              <!-- <option>Fix price</option> -->
            </select>
          </div>
          <div class="btn-group" role="group">
            <button
              v-for="(item, id) in items"
              :key="id"
              :class="{ active: isActive(item) }"
              @click="toggleActive(item)"
              class="btn btn-outline-primary btn-group-custom"
              type="button"
            >
              {{ item.label }}
            </button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-2" style="padding: 0 6px 0 12px">
          <CardWhite
            v-if="dataGeneration != null"
            :param="dataGeneration.list[0]"
            :height="150"
            :selected="selectedCard === dataGeneration.list[0].metricId"
            @click="selectCard(dataGeneration.list[0])"
            :achievement="true"
            :trend="true"
          ></CardWhite>
        </div>
        <div class="col-2" style="padding: 0 6px">
          <CardWhite
            v-if="dataGeneration != null"
            :param="dataGeneration.list[1]"
            :height="150"
            :selected="selectedCard === dataGeneration.list[1].metricId"
            @click="selectCard(dataGeneration.list[1])"
            :achievement="true"
            :trend="true"
          ></CardWhite>
        </div>
        <div class="col-2" style="padding: 0 6px">
          <CardWhite
            v-if="dataGeneration != null"
            :param="dataGeneration.list[2]"
            :height="150"
            :selected="selectedCard === dataGeneration.list[2].metricId"
            @click="selectCard(dataGeneration.list[2])"
            :achievement="true"
            :trend="true"
          ></CardWhite>
        </div>
        <div class="col-2" style="padding: 0 6px">
          <CardWhite
            v-if="dataGeneration != null"
            :param="dataGeneration.list[3]"
            :height="150"
            :selected="selectedCard === dataGeneration.list[3].metricId"
            @click="selectCard(dataGeneration.list[3])"
            :achievement="true"
            :trend="true"
          ></CardWhite>
        </div>
        <div class="col-2" style="padding: 0 6px">
          <CardWhite
            v-if="dataGeneration != null"
            :param="dataGeneration.list[4]"
            :height="150"
            :selected="selectedCard === dataGeneration.list[4].metricId"
            @click="selectCard(dataGeneration.list[4])"
            :achievement="true"
            :trend="true"
            :chart="true"
            @showGraph="onShowModalCauses"
          ></CardWhite>
        </div>
        <div class="col-2" style="padding: 0 12px 0 6px">
          <CardWhite
            v-if="dataGeneration != null"
            :param="dataGeneration.list[5]"
            :height="150"
            :selected="selectedCard === dataGeneration.list[5].metricId"
            @click="selectCard(dataGeneration.list[5])"
            :achievement="true"
            :trend="true"
          ></CardWhite>
        </div>
      </div>
      <div class="row">
        <div class="col-md-10">
          <div class="header-top m-t-5" style="margin-bottom: 12px">
            <h5 class="m-0 sub_title_1">{{ titleMap }}</h5>
            <div style="display: flex; gap: 20px">
              <div class="card-header-right-icon">
                <span
                  class="badge badge-light text-dark"
                  v-if="dataGenerationRegion != null"
                  >{{ dataGenerationRegion.totalCount }} Unit</span
                >
                <span class="badge badge-light text-dark">
                  Status:
                  <span
                    @click="filterNormal = !filterNormal"
                    v-bind:style="filterNormal ? '' : 'opacity: 0.3'"
                    style="cursor: pointer"
                  >
                    <img
                      width="16"
                      height="16"
                      src="@/assets/images/svg-icon/badge-checkbox-green.svg"
                    />
                    Normal: Cadangan daya >30% ({{ normal }})
                  </span>
                  <span
                    @click="filterSiaga = !filterSiaga"
                    v-bind:style="filterSiaga ? '' : 'opacity: 0.3'"
                    style="cursor: pointer"
                  >
                    <img
                      width="16"
                      height="16"
                      src="@/assets/images/svg-icon/badge-checkbox-orange.svg"
                    />
                    Siaga: Cadangan daya 0-30% ({{ siaga }})
                  </span>
                  <span
                    @click="filterDefisit = !filterDefisit"
                    v-bind:style="filterDefisit ? '' : 'opacity: 0.3'"
                    style="cursor: pointer"
                  >
                    <img
                      width="16"
                      height="16"
                      src="@/assets/images/svg-icon/badge-checkbox-red.svg"
                    />
                    Defisit: Cadangan daya < 0% ({{ defisit }})
                  </span>
                </span>
              </div>
            </div>
          </div>
          <!--<img style="width: 100%" src="@/assets/images/indonesia.png" />-->
          <div>
            <l-map
              :dragging="false"
              :zoom="mapGeneration.zoom"
              :minZoom="mapGeneration.minZoom"
              :maxZoom="mapGeneration.maxZoom"
              :center="mapGeneration.center"
              style="height: 500px; z-index: 0"
              :options="mapGeneration"
              :zoomControl="false"
              @move="onMapMove"
              ref="map"
              :bounds="bounds"
              :max-bounds="maxBounds"
            >
              <l-tile-layer :url="mapGeneration.url"></l-tile-layer>

              <l-marker
                v-if="
                  dataGenerationRegion != null &&
                  dataGenerationRegionDetail == null
                "
                v-for="(marker, index) in dataGenerationRegion.list"
                :lat-lng="[marker.latitude, marker.longitude]"
                :icon="
                  marker.value > 30
                    ? mapGeneration.iconGreen
                    : marker.value > 0 && marker.value <= 30
                    ? mapGeneration.iconOrange
                    : mapGeneration.iconRed
                "
                @click="clickMarker(marker)"
                ><l-tooltip>
                  <div>
                    {{ titleMap }}<br />
                    {{ marker.instanceName }}<br />
                    {{ marker.value }}
                  </div>
                </l-tooltip></l-marker
              >

              <l-marker
                v-if="dataGenerationRegionDetail != null"
                v-for="(marker, index) in dataGenerationRegionDetail.list"
                :lat-lng="[marker.latitude, marker.longitude]"
                :icon="
                  marker.value > 30
                    ? mapGeneration.iconGreen
                    : marker.value > 0 && marker.value <= 30
                    ? mapGeneration.iconOrange
                    : mapGeneration.iconRed
                "
                ><l-tooltip>
                  <div>
                    {{ marker.projectName }}<br />
                    {{ marker.value }}
                  </div>
                </l-tooltip></l-marker
              >
            </l-map>
          </div>
        </div>
        <div class="col-md-2" style="padding: 0 12px 0 6px">
          <div
            class="card card_white"
            style="height: 552px; margin-bottom: 12px"
          >
            <div class="text-center">
              <div>
                <apexchart
                  type="radialBar"
                  width="100%"
                  height="250"
                  :options="chartOptions"
                  :series="series"
                ></apexchart>
              </div>
              <div>
                <div class="font-label-10">DMN (MW)</div>
                <div
                  v-if="dataGeneration != null"
                  class="font-data-16 mb-2"
                  style="color: #000000"
                >
                  {{ formattedNumber(dataGeneration.list[6].value) }}
                </div>
              </div>
              <div>
                <div class="font-label-10">DMP (MW)</div>
                <div
                  v-if="dataGeneration != null"
                  class="font-data-16 mb-2"
                  style="color: #9e00d6"
                >
                  {{ formattedNumber(dataGeneration.list[7].value) }}
                </div>
              </div>
              <div>
                <div class="font-label-10">BP (MW)</div>
                <div
                  v-if="dataGeneration != null"
                  class="font-data-16 mb-2"
                  style="color: #00a3e9"
                >
                  {{ formattedNumber(dataGeneration.list[8].value) }}
                </div>
              </div>
              <div>
                <div class="font-label-10">CAD (MW)</div>
                <div
                  v-if="dataGeneration != null"
                  class="font-data-16 mb-2"
                  style="color: #00aa4e"
                >
                  {{ formattedNumber(dataGeneration.list[9].value) }}
                  <!--<span
                    style="
                      color: #595959;
                      font-size: 12px;
                      font-weight: 400;
                      line-height: 14.52px;
                    "
                    >(32.87%)</span
                  >-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="dataGeneration != null" class="row">
        <div class="col-md-12">
          <div class="card card_white" style="margin-bottom: 12px">
            <div
              class="m-5"
              style="display: flex; justify-content: space-between"
            >
              <div>
                <img
                  width="16"
                  height="16"
                  src="@/assets/images/svg-icon/icon-pltd.svg"
                />

                {{
                  dataGeneration.dataPowerPlant[0].metricname +
                  " (" +
                  formattedNumber(dataGeneration.dataPowerPlant[0].value) +
                  ")"
                }}
              </div>
              <div>
                <img
                  width="16"
                  height="16"
                  src="@/assets/images/svg-icon/icon-pltg.svg"
                />
                {{
                  dataGeneration.dataPowerPlant[1].metricname +
                  " (" +
                  formattedNumber(dataGeneration.dataPowerPlant[1].value) +
                  ")"
                }}
              </div>
              <div>
                <img
                  width="16"
                  height="16"
                  src="@/assets/images/svg-icon/icon-pltp.svg"
                />
                {{
                  dataGeneration.dataPowerPlant[2].metricname +
                  " (" +
                  formattedNumber(dataGeneration.dataPowerPlant[2].value) +
                  ")"
                }}
              </div>
              <div>
                <img
                  width="16"
                  height="16"
                  src="@/assets/images/svg-icon/icon-pltgu.svg"
                />
                {{
                  dataGeneration.dataPowerPlant[3].metricname +
                  " (" +
                  formattedNumber(dataGeneration.dataPowerPlant[3].value) +
                  ")"
                }}
              </div>
              <div>
                <img
                  width="16"
                  height="16"
                  src="@/assets/images/svg-icon/icon-pltmh.svg"
                />
                {{
                  dataGeneration.dataPowerPlant[4].metricname +
                  " (" +
                  formattedNumber(dataGeneration.dataPowerPlant[4].value) +
                  ")"
                }}
              </div>
              <div>
                <img
                  width="16"
                  height="16"
                  src="@/assets/images/svg-icon/icon-plts.svg"
                />
                {{
                  dataGeneration.dataPowerPlant[5].metricname +
                  " (" +
                  formattedNumber(dataGeneration.dataPowerPlant[5].value) +
                  ")"
                }}
              </div>
              <div>
                <img
                  width="16"
                  height="16"
                  src="@/assets/images/svg-icon/icon-pltm.svg"
                />
                {{
                  dataGeneration.dataPowerPlant[6].metricname +
                  " (" +
                  formattedNumber(dataGeneration.dataPowerPlant[6].value) +
                  ")"
                }}
              </div>
              <div>
                <img
                  width="16"
                  height="16"
                  src="@/assets/images/svg-icon/icon-plta.svg"
                />
                {{
                  dataGeneration.dataPowerPlant[7].metricname +
                  " (" +
                  formattedNumber(dataGeneration.dataPowerPlant[7].value) +
                  ")"
                }}
              </div>
              <div>
                <img
                  width="16"
                  height="16"
                  src="@/assets/images/svg-icon/icon-pltbm.svg"
                />
                {{
                  dataGeneration.dataPowerPlant[8].metricname +
                  " (" +
                  formattedNumber(dataGeneration.dataPowerPlant[8].value) +
                  ")"
                }}
              </div>
              <div>
                <img
                  width="16"
                  height="16"
                  src="@/assets/images/svg-icon/icon-pltu.svg"
                />
                {{
                  dataGeneration.dataPowerPlant[9].metricname +
                  " (" +
                  formattedNumber(dataGeneration.dataPowerPlant[9].value) +
                  ")"
                }}
              </div>
              <div>
                <img
                  width="16"
                  height="16"
                  src="@/assets/images/svg-icon/icon-pltb.svg"
                />
                {{
                  dataGeneration.dataPowerPlant[10].metricname +
                  " (" +
                  formattedNumber(dataGeneration.dataPowerPlant[10].value) +
                  ")"
                }}
              </div>
              <div>
                <img
                  width="16"
                  height="16"
                  src="@/assets/images/svg-icon/icon-pltmg.svg"
                />
                {{
                  dataGeneration.dataPowerPlant[11].metricname +
                  " (" +
                  formattedNumber(dataGeneration.dataPowerPlant[11].value) +
                  ")"
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-2" style="padding: 0 6px 0 12px">
          <CardWhite
            v-if="dataGeneration != null"
            :param="dataGeneration.list[10]"
            :height="150"
            :selected="selectedCard === dataGeneration.list[10].metricId"
            @click="selectCard(dataGeneration.list[10])"
            :achievement="true"
            :trend="true"
          ></CardWhite>
        </div>
        <div class="col-2" style="padding: 0 6px">
          <CardWhite
            v-if="dataGeneration != null"
            :param="dataGeneration.list[11]"
            :height="150"
            :selected="selectedCard === dataGeneration.list[11].metricId"
            @click="selectCard(dataGeneration.list[11])"
            :achievement="true"
            :trend="true"
          ></CardWhite>
        </div>
        <div class="col-2" style="padding: 0 6px">
          <CardWhite
            v-if="dataGeneration != null"
            :param="dataGeneration.list[12]"
            :height="150"
            :selected="selectedCard === dataGeneration.list[12].metricId"
            @click="selectCard(dataGeneration.list[12])"
            :achievement="true"
            :trend="true"
          ></CardWhite>
        </div>
        <div class="col-2" style="padding: 0 6px">
          <CardWhite
            v-if="dataGeneration != null"
            :param="dataGeneration.list[13]"
            :height="150"
            :selected="selectedCard === dataGeneration.list[13].metricId"
            @click="selectCard(dataGeneration.list[13])"
            :achievement="true"
            :trend="true"
          ></CardWhite>
        </div>
        <div class="col-4" style="padding: 0 12px 0 6px">
          <div class="card card_white" style="height: 150px">
            <div class="row" style="height: 100%">
              <div class="col-2">
                <div
                  style="
                    height: 100%;
                    border-right: 1px solid #e5e7ed;
                    align-content: center;
                  "
                >
                  SFC
                </div>
              </div>
              <div class="col-10">
                <div class="row">
                  <div class="col-4">
                    <CardWhite
                      v-if="dataGeneration != null"
                      :param="dataGeneration.list[14]"
                      noBorder
                      :achievement="true"
                    ></CardWhite>
                  </div>
                  <div class="col-4">
                    <CardWhite
                      v-if="dataGeneration != null"
                      :param="dataGeneration.list[15]"
                      noBorder
                      :achievement="true"
                    ></CardWhite>
                  </div>
                  <div class="col-4">
                    <CardWhite
                      v-if="dataGeneration != null"
                      :param="dataGeneration.list[16]"
                      noBorder
                      :achievement="true"
                    ></CardWhite>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import IconSvg from "@/components/IconSvg.vue";
import {
  LMap,
  LTileLayer,
  LMarker,
  LIcon,
  LTooltip,
} from "@vue-leaflet/vue-leaflet";
import { latLngBounds, icon } from "leaflet";

import GenerationService from "../../../services/generation/generation";
import ReferenceService from "@/services/reference/reference";

import CardWhite from "./CardWhite.vue";
import { formattedNumber } from "@/utils/helper";
import { marker } from "leaflet";
import "leaflet/dist/leaflet.css";

const getReference = ReferenceService.build();
const getGeneration = GenerationService.build();
export default {
  props: ["last_update", "data"],
  components: {
    IconSvg,
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LTooltip,
    CardWhite,
  },
  data() {
    return {
      dataSystem: [],
      titleMap: "",
      activeItem: null,
      items: [
        { value: "pip", label: "PIP", active: true },
        { value: "pnp", label: "PNP", active: false },
        { value: "ipp", label: "IPP", active: false },
        { value: "reg_opdis_batam", label: "BATAM", active: false },
        { value: "excess", label: "EXCESS", active: false },
        { value: "holding", label: "HOLDING", active: false },
        { value: "nusa_daya", label: "NUSA DAYA", active: false },
        { value: "pt_mctn", label: "MCTN", active: false },
      ],
      normal: null,
      siaga: null,
      defisit: null,
      dataGeneration: null,
      dataGenerationRegion: null,
      dataGenerationRegionDetail: null,
      dataGenerationPlant: [],
      filterNormal: true,
      filterSiaga: true,
      filterDefisit: true,
      modalCauses: {
        show: false,
        load: false,
      },
      modalGenerationSystems: {
        show: false,
        load: false,
      },
      modalElectricityGenerated: {
        show: false,
        load: false,
      },
      series: [44, 55, 67],
      chartOptions: {
        chart: {
          height: 100,
          type: "radialBar",
        },
        plotOptions: {
          radialBar: {
            dataLabels: {
              name: {
                fontSize: "22px",
              },
              value: {
                fontSize: "16px",
              },
              total: {
                show: false,
                label: "Total",
                formatter: function (w) {
                  // By default this function returns the average of all series. The below is just an example to show the use of custom formatter function
                  return 249;
                },
              },
            },
          },
        },
        colors: ["#00aa4e", "#00a3e9", "#9e00d6"],
        labels: ["CAD", "BP", "DMP"],
      },
      bounds: "",
      maxBounds: "",
      powerPlant: "all",
      dataPP: [],
      mapGeneration: {
        zoomControl: false,
        dragging: false,
        doubleClickZoom: false,
        scrollWheelZoom: false,
        zoom: 5,
        minZoom: 3,
        maxZoom: 18,
        center: [-1.8263233, 120.3522204],
        markerGreen: [
          {
            latlong: [1.0367968, 97.6884662],
            instanceName: "Nias",
            cadanganDaya: "35%",
          }, //nias
          {
            latlong: [1.0052943, 103.4258705],
            instanceName: "Tanjung Balai / Karimun",
            cadanganDaya: "35%",
          }, //tanjung balai karimun
          {
            latlong: [1.0729587, 104.0416892],
            instanceName: "Batam - Bintan",
            cadanganDaya: "35%",
          }, //batam bintan
          {
            latlong: [-2.9117616, 107.9023643],
            instanceName: "Belitung",
            cadanganDaya: "35%",
          }, //belitung
          {
            latlong: [-2.0007022, 110.1202854],
            instanceName: "Ketapang",
            cadanganDaya: "35%",
          }, //ketapang
          {
            latlong: [3.3148851, 117.5907554],
            instanceName: "Tarakan",
            cadanganDaya: "35%",
          }, //tarakan
          {
            latlong: [2.8503988, 117.3659891],
            instanceName: "Tanjung Selor",
            cadanganDaya: "35%",
          }, //tanjung selor
          {
            latlong: [-1.1745987, 116.6858597],
            instanceName: "Interkoneksi Kalimantan - Balikpapan",
            cadanganDaya: "35%",
          }, //interkoneksi kalimantan balikpapan
          {
            latlong: [-8.5830806, 116.108191],
            instanceName: "Lombok",
            cadanganDaya: "35%",
          }, //lombok
          {
            latlong: [-8.4897113, 117.8809845],
            instanceName: "Tambora",
            cadanganDaya: "35%",
          }, //tambora
          {
            latlong: [-8.5921843, 120.8658781],
            instanceName: "Flores",
            cadanganDaya: "35%",
          }, //flores
          {
            latlong: [-9.663439, 123.9943677],
            instanceName: "Timor",
            cadanganDaya: "35%",
          }, //timor
          {
            latlong: [1.47483, 124.842079],
            instanceName: "Manado",
            cadanganDaya: "35%",
          }, // Manado
          {
            latlong: [0.7348268, 127.3850732],
            instanceName: "Ternate - Tidore",
            cadanganDaya: "35%",
          }, // Ternate Tidore
          {
            latlong: [-0.876163, 131.255828],
            instanceName: "Sorong",
            cadanganDaya: "35%",
          }, // Sorong
          {
            latlong: [-0.861453, 134.069356],
            instanceName: "Manokwari",
            cadanganDaya: "35%",
          }, // Manokwari
          {
            latlong: [-2.53371, 140.71813],
            instanceName: "Jayapura",
            cadanganDaya: "35%",
          }, // Jayapura
        ],
        markerOrange: [
          {
            latlong: [-0.17615, 101.4273751],
            instanceName: "Sumatera",
            cadanganDaya: "12%",
          }, //sumatera
          {
            latlong: [-7.3480589, 110.0276928],
            instanceName: "Jamali",
            cadanganDaya: "12%",
          }, //jamali
          {
            latlong: [-0.0374548, 109.323825],
            instanceName: "Pontianak Khatulistiwa",
            cadanganDaya: "12%",
          }, //pontianak khatulistiwa
          {
            latlong: [-5.5100044, 122.5922232],
            instanceName: "Baubau",
            cadanganDaya: "12%",
          }, //baubau
        ],
        markerRed: [
          {
            latlong: [-4.1558642, 120.1808723],
            instanceName: "Sulbagsel",
            cadanganDaya: "-2%",
          }, //sulbagsel
        ],

        markerJamali: [],

        iconGreen: icon({
          iconUrl: "map-marker-diamond-green.svg",
          iconSize: [16, 16],
          iconAnchor: [8, 8],
        }),
        iconOrange: icon({
          iconUrl: "map-marker-diamond-orange.svg",
          iconSize: [16, 16],
          iconAnchor: [8, 8],
        }),
        iconRed: icon({
          iconUrl: "map-marker-diamond-red.svg",
          iconSize: [16, 16],
          iconAnchor: [8, 8],
        }),

        url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
        //url: "https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png",
      },
      selectedCard: null,
      selectedRegion: null,
    };
  },
  mounted() {},
  created() {
    this.activeItem = this.items[0];
    // this.getGenerationRegion("consolidated@ELECTRICITY_GENERATION@20231225");
    // this.getGeneration("all", "");
    this.getPP();
  },
  watch: {
    powerPlant() {
      this.getGeneration(this.powerPlant, "consolidated");
    },
  },
  methods: {
    async getPP() {
      const res = await getReference.getPowerPlant();
      this.dataPP = res.data.data;
      const defaults = {
        label: "All",
        value: "all",
        disabled: true,
      };
      this.dataPP.push(defaults);
    },
    onMapMove(event) {},
    isActive(item) {
      return item === this.activeItem;
    },
    toggleActive(item) {
      if (this.activeItem === item) {
        this.activeItem = null; // Toggle to inactive if already active
      } else {
        this.activeItem = item; // Set as active if not already active
        this.getGeneration("all", item.value);
        this.mapGeneration.zoom = 5;
        this.selectedRegion = null;
        this.dataGenerationRegionDetail = null;
        // this.mapGeneration.center = [-1.8263233, 120.3522204];
      }
    },
    btnGroups(x, y) {
      // this.btnGroup[y].active = !this.btnGroup[y].active;
      if (this.activeItem === x) {
        this.activeItem = null; // Toggle to inactive if already active
      } else {
        this.activeItem = x; // Set as active if not already active
      }
    },

    selectCard(id) {
      this.selectedCard = id.metricId;
      this.titleMap = id.metricName;
      this.mapGeneration.zoom = 5;
      this.selectedRegion = null;
      this.dataGenerationRegionDetail = null;
      this.mapGeneration.center = [-1.8263233, 120.3522204];
      this.getGenerationRegion(id.id);
    },

    clickMarker(marker) {
      // this.$refs.map.mapObject.setView(
      //   -6.315030299999987,
      //   106.26636210000001,
      //   15
      // );
      this.mapGeneration.zoom = 10;
      this.mapGeneration.center = [marker.latitude, marker.longitude];
      // (this.bounds = latLngBounds([
      //   [marker.latitude, marker.longitude],
      //   // [-6.2572534, 106.7597913],
      // ])),
      // (this.maxBounds = latLngBounds([
      //   [-6.2572534, 106.7597913],
      //   [-6.315030299999987, 106.26636210000001],
      // ])),
      this.getGenerationRegionDetail(marker.id);
      this.selectedRegion = marker;
      //this.setZoom(7)
    },

    deselectRegion() {
      (this.mapGeneration.center = [-1.8263233, 118.3522204]),
        (this.selectedRegion = null);
      this.mapGeneration.zoom = 5;
      this.dataGenerationRegionDetail = null;
      this.getGenerationRegion("consolidated@ELECTRICITY_GENERATION@20231225");
    },

    setZoom(zoom) {
      this.mapGeneration.zoom = zoom;
    },

    async getGeneration(typeGeneration, instanceId) {
      let param = Object.assign({
        typeGeneration: typeGeneration,
        instanceId: instanceId,
      });
      const res = await getGeneration.getDataGeneration(param);
      this.selectCard(res.data.data.list[0]);
      this.dataGeneration = res.data.data;
    },
    async getGenerationRegion(directorate) {
      // this.dataGenerationRegion = null;
      let param = Object.assign({
        directorate: directorate,
        instanceId: "pip",
        category: "All",
      });
      const res = await getGeneration.getDataGenerationRegion(param);
      const data = res.data.data;
      this.normal = data.normalCount;
      this.siaga = data.siagaCount;
      this.defisit = data.defisitCount;
      this.dataGenerationRegion = res.data.data;
    },
    async getGenerationRegionDetail(cities) {
      let param = Object.assign({
        cities: cities,
      });
      const res = await getGeneration.getDataGenerationRegionDetail(param);
      this.dataGenerationRegionDetail = res.data.data;
    },
    async getGenerationPlant() {
      const res = await getGeneration.getDataGenerationPlant();
      this.dataGenerationPlant = res.data.data;
    },
    onShowModalCauses() {
      this.modalCauses.show = true;
    },
    onCloseModalCauses(value) {
      this.modalCauses.show = value;
    },
    async onShowModalGenerationSystems() {
      const param = {
        directorate: "a;;",
      };
      const res = await getGeneration.getDataGenerationSystem(param);
      this.dataSystem = res.data.data;
      this.modalGenerationSystems.show = true;
    },
    onCloseModalGenerationSystems(value) {
      this.modalGenerationSystems.show = value;
    },
    onShowModalElectricityGenerated() {
      this.modalElectricityGenerated.show = true;
    },
    onCloseModalElectricityGenerated(value) {
      this.modalElectricityGenerated.show = value;
    },
    formattedNumber,
  },
};
</script>

<style scoped>
.btn-group-custom {
  background-color: #e6e6e6;
  color: #838383;
  border: none;
}
.btn-group-custom:hover,
.btn-group-custom:focus,
.btn-group-custom:active,
.btn-group-custom.active {
  background-color: #00a3e9 !important;
  color: #fff !important;
  border: none !important;
}

.font-label-10 {
  font-size: 10px;
  font-weight: 400;
  line-height: 12.1px;
}

.font-data-16 {
  font-size: 16px;
  font-weight: 700;
  line-height: 19.36px;
}

.text-detail:hover {
  color: #00A3E9;
}
</style>
